// Core
import React from "react";

//Styles
import "./styles.scss";

//Svg
import AuthBanner from "../../Assets/Images/AuthBanner.jpg";
import LOGO from "../../Assets/Svg/Auth/Logo.svg";

//Custom components
import FooterColorLine from "Components/FooterColorLine";

const AuthLayout = ({ children }) => {
  return (
    <>
      <div className="auth-layout-root-container">
        <div className="auth-layout-left-container">
          <div
            className="auth-layout-left-container-bg-image"
            style={{
              backgroundImage: `url(${AuthBanner})`,
              backgroundSize: "center",
            }}
          >
            <div
              className="auth-layout-black-layer"
              style={
                process.env.REACT_APP_KG_ASSESMENT_ENV === "accessor"
                  ? {
                      gap: 30,
                    }
                  : {}
              }
            >
              <img src={LOGO} alt="LOGO" />
              {process.env.REACT_APP_KG_ASSESMENT_ENV === "accessor" ? (
                <p className="auth-layout-accessor-text">
                  KG Maintenance Assesments
                </p>
              ) : (
                <p className="auth-layout-text">
                  MAINTENANCE <br /> ASSESSMENT PORTAL
                </p>
              )}
              {process.env.REACT_APP_KG_ASSESMENT_ENV === "accessor" && (
                <p className="auth-layout-accessor-footer-text">
                  Sales Person Portal
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="auth-layout-right-container">{children}</div>
      </div>
      <div className="auth-layout-footer">
        <FooterColorLine />
      </div>
    </>
  );
};

export default AuthLayout;
